import type { SupabaseClient } from '@supabase/supabase-js';

export type CaliforniaEvFleetResolution =
  | { count: number; method: 'state_emfac_row'; vintageYear: number }
  | { count: null; method: null; vintageYear: number };

const PLUG_IN_FUELS = ['Electric', 'PluginHybrid'];

/**
 * Resolve California plug-in fleet count without population-scaling from a selected city.
 * 1) Direct compatible California row (geofips=6) in emfac2025_fleet_mat, then emfac2021_fleet_mat
 * 2) Unavailable — city sums are not used (incomplete jurisdiction coverage / unincorporated areas).
 */
export async function resolveCaliforniaPlugInEvCount(
  client: SupabaseClient,
  vintageYear = 2023
): Promise<CaliforniaEvFleetResolution> {
  const { data: ca2025Data } = await client
    .from('emfac2025_fleet_mat')
    .select('vehicle_population, fuel_type')
    .eq('geofips', 6)
    .eq('geography_type', 'State')
    .eq('year', vintageYear)
    .in('fuel_type', PLUG_IN_FUELS);

  if (ca2025Data && ca2025Data.length > 0) {
    const count = ca2025Data.reduce((sum, r) => sum + Number(r.vehicle_population || 0), 0);
    if (count > 0) {
      return { count, method: 'state_emfac_row', vintageYear };
    }
  }

  const { data: ca2021State } = await client
    .from('emfac2021_fleet_mat')
    .select('vehicle_population, fuel_type')
    .eq('geofips', 6)
    .eq('geography_type', 'State')
    .eq('year', vintageYear)
    .in('fuel_type', PLUG_IN_FUELS);

  if (ca2021State && ca2021State.length > 0) {
    const count = ca2021State.reduce((sum, r) => sum + Number(r.vehicle_population || 0), 0);
    if (count > 0) {
      return { count, method: 'state_emfac_row', vintageYear };
    }
  }

  return { count: null, method: null, vintageYear };
}
